var _a;
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';
import * as actions from '../constants/actionTypes';
var returnItems = handleActions((_a = {},
    _a[actions.addReturnItems.type.REQUEST] = function (_, _a) {
        var payload = _a.payload;
        return payload;
    },
    _a), []);
export default combineReducers({
    returnItems: returnItems,
});
//# sourceMappingURL=native.js.map